import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = ['id', 'email', 'updated_at', 'first_prompt', 'second_prompt', 'third_prompt', 'fourth_prompt'];

export const getWaterfallFlow = asyncThunkWrapper({ 
  model: 'waterfallFlow', 
  action: 'getWaterfallFlow', 
  func: async () => {
    const params = { attributes };
    const response = await axios.get(`/waterfall_flow`, { params });

    return response.data;
  } 
});
export const createWaterfallFlow = asyncThunkWrapper({ 
  model: 'waterfall_flow', 
  action: 'createWaterfallFlow', 
  func: async (waterfall_flow) => {
    const response = await axios.post(`/waterfall_flow`, { waterfall_flow, attributes });

    return response.data;
  } 
});
export const updateWaterfallFlow = asyncThunkWrapper({ 
  model: 'waterfallFlow', 
  action: 'updateWaterfallFlow', 
  func: async (waterfall_flow) => {
    const response = await axios.patch(`/waterfall_flow`, { waterfall_flow });

    return { status: response.status, waterfall_flow };
  } 
});
export const deleteWaterfallFlow = asyncThunkWrapper({ 
  model: 'waterfallFlow', 
  action: 'deleteWaterfallFlow', 
  func: async () => {
    const response = await axios.delete(`/waterfall_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveWaterfallFlow = createAction('waterfallFlow/clearLocalActiveWaterfallFlow');